import axios, { AxiosResponse } from 'axios';
import { IUserInformationFormValues } from '../../components/pages/Setting/Access/User/UserInformation';
import { IUserMemberManageFormValues } from '../../components/pages/Setting/Access/User/UserMemberManage';
import { IPermission } from '../../compiler/global.interface';
import md5 from 'md5'
import { IGroup } from '../../pages/Setting/Access/UserGroup';
import { IGroupFormValues } from '../../components/pages/Setting/Access/UserGroup/UserGroupInformation';
import { IMemberInGroupFormValues } from '../../components/pages/Setting/Access/UserGroup/UserGroupManage';

export async function APIGetAllGroups() {
    try {
        let result: AxiosResponse = await axios.get('/user-group-master')
        return result.data
    } catch (error) {
        throw new Error(`Error At APIGetAllGroups : ${error}`);
    }
}

export async function APIGetGroupMembersByUUID(uuid:string) {
    try {
        let result: AxiosResponse = await axios.get(`/user-group/group/${uuid}`)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIGetGroupMembersByUUIDs : ${error}`);
    }
}

export async function APIGetMemberGroupByUUID(uuid:string) {
    try {
        let result: AxiosResponse = await axios.get(`/user-group/user/${uuid}`)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIGetGroupMembersByUUIDs : ${error}`);
    }
}

export async function APIGetGroupPermissionByUUID(uuid:string) {
    try {
        let result: AxiosResponse = await axios.get(`/roles-user-group-permission/group/${uuid}`)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIGetGroupPermissionByUUID : ${error}`);
    }
}

export async function APIUpdateGroupPermissionByUUID(uuid: string, payload: { permissionData: IPermission[] }) {

    let body = {
        group_master_uuid: uuid,
        roles: payload.permissionData.map(role => ({
            roles_code:role.roles_code,
            read:role.read,
            create:role.create,
            update:role.update,
            delete:role.delete,
            approve:role.approve
        }))
    }

    try {
        let result: AxiosResponse = await axios.post(`/roles-user-group-permission`,body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APISaveGroupPermissionByUUID : ${error}`);
    }
}

export async function APICreateGroup(payload: IGroupFormValues) {

    const body = {
        name: payload.name?.trim(),
        description: payload.description?.trim()
    }

    try {
        let result: AxiosResponse = await axios.post('/user-group-master', body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APICreateGroup : ${error}`);
    }
}

export async function APIAddMemberToGroupByUUID(uuid, payload: { members: IMemberInGroupFormValues[] }) {
    let body = {
        group_master_uuid: uuid,
        users: payload.members.map(user => ({ id:user.id, user_uuid: user.uuid,is_remove:user?.is_remove }))
    }
    
    try {
        let result: AxiosResponse = await axios.post('/user-group/user', body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIAddMemberToGroupByUUID : ${error}`);
    }
}

export async function APIUpdateGroupByUUID(uuid: string, payload: IGroupFormValues) {
    let body = {
        name: payload.name?.trim(),
        description: payload.description?.trim(),
        id: payload.id,
        uuid: payload.uuid
    }

    try {
        let result: AxiosResponse = await axios.patch(`/user-group-master/${uuid}`, body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIUpdateGroupByUUID : ${error}`);
    }
}

export async function APIUpdateGroupUserByUUID(uuid: string | null, payload: IPermission[]) {
    try {
        console.log(uuid, '@@APIUpdateGroupUserByUUID.uuid')
        console.log(payload, '@@APIUpdateGroupUserByUUID.payload')
        // let result: AxiosResponse = await axios.post('/user-master/')
        // return result.data
    } catch (error) {
        throw new Error(`Error AtAPIUpdateUserInGroupByUUID : ${error}`);
    }
}
